import { TrackingAnalytics } from './TrackingAnalytics';

export const EnterpriseAnalytics = {
  exportedCSV () {
    TrackingAnalytics.send('EA-Exports CSV');
  },
  backToPopin () {
    TrackingAnalytics.send('EA-Back to POPin');
  },
  dateRangeSwitched (prevDateRange, nextDateRange) {
    let props = {
      prev_date_range: prevDateRange,
      next_date_range: nextDateRange
    };
    TrackingAnalytics.send('EA-Switches Date Range', props);
  },
  hoversTooltip (infoIcon) {
    let props = {
      info_icon: infoIcon
    };
    TrackingAnalytics.send('EA-Hovers help icon', props);
  },
  searchedCreators () {
    TrackingAnalytics.send('EA-Searches Creators');
  },
  searchedPopins () {
    TrackingAnalytics.send('EA-Searches POPins');
  },
  searchedUpcomingPopins () {
    TrackingAnalytics.send('EA-Searches Upcoming POPins')
  },
  sortsCreators (fieldToSortBy) {
    let props = {
      field_to_sort_by: fieldToSortBy
    };
    TrackingAnalytics.send('EA-Sorts Creators', props);
  },
  sortsCreatorsByName () {
    this.sortsCreators('name');
  },
  sortsCreatorsByEmail () {
    this.sortsCreators('email');
  },
  sortsCreatorsByPopins () {
    this.sortsCreators('popins');
  },
  sortsCreatorsByReach () {
    this.sortsCreators('reach');
  },
  sortsCreatorsByLastPopin () {
    this.sortsCreators('last popin');
  },
  sortsPopins (fieldToSortBy) {
    let props = {
      field_to_sort_by: fieldToSortBy
    };
    TrackingAnalytics.send('EA-Sorts POPins', props);
  },
  sortsPopinsByStartTime () {
    this.sortsPopins('start time');
  },
  sortsPopinsByName () {
    this.sortsPopins('name');
  },
  sortsPopinsByEmail () {
    this.sortsPopins('email');
  },
  sortsPopinsByUseCase () {
    this.sortsPopins('use case');
  },
  sortsPopinsByUsers () {
    this.sortsPopins('users');
  },
  sortsPopinsByActivities () {
    this.sortsPopins('activities');
  },
  sortsUpcomingPopins (fieldToSortBy) {
    let props = {
      field_to_sort_by: fieldToSortBy
    };
    TrackingAnalytics.send('EA-Sorts Upcoming POPins', props);
  },
  sortsUpcomingPopinsByStartTime () {
    this.sortsUpcomingPopins('start time');
  },
  sortsUpcomingPopinsByName () {
    this.sortsUpcomingPopins('name');
  },
  sortsUpcomingPopinsByEmail () {
    this.sortsUpcomingPopins('email');
  },
  sortsUpcomingPopinsByUseCase () {
    this.sortsUpcomingPopins('use case');
  },
  permErrorModalShown () {
    TrackingAnalytics.send('EA~PermErr~Modal shown')
  },
  permErrContactOwner () {
    TrackingAnalytics.send('EA-PermErr-Contact owner')
  },
  permErrLearnMore () {
    TrackingAnalytics.send('EA-PermErr-Learn more');
  }
};
